import React from 'react';
import languages from '../appdata/languages';
import StoreManager from '../appdata';
import resources from '../resources';
import TextSection3 from '../components/BaseComponents/TextSection3';
import { Row, Col } from 'antd';

class ChairmanMessage extends React.Component {
  state = {
    expanded: false, // thêm state để kiểm soát
  };

  handleSeeMore = () => {
    this.setState({ expanded: true });
  };

  render() {
    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const content = languages[lang].ChairmanMessageContent;
    const { expanded } = this.state;
    const { isMobile } = StoreManager.appState.thisApp.state

    const baseTextStyle = {
      fontSize: 16,
      lineHeight: '24px',
      color: '#202020',
      marginBottom: 20,
    };

    const boldTextStyle = {
      ...baseTextStyle,
      fontWeight: 500,
    };

    return (
      <section style={{ padding: '80px 16px', maxWidth: 1040, margin: '0 auto' }}>
        <Row style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
          <Col xs={24} md={14} style={{paddingRight: isMobile ? 0 : 20}}>
            <p style={{ fontSize: 32, fontWeight: 400, marginBottom: 2, textAlign:'left' }}>
              {content.heading}
            </p>

            {/* Hiển thị content.body hoặc content.bodyFull */}
            <TextSection3
              title={content.title}
              paragraphs={content.body}
              marginBottom={0}
            />
          </Col>
          <Col xs={24} md={10} style={{padding: 0}}>
          <img
            src={resources.images.ChairmanMessageImage1}
            style={{ width: '100%',  height: 'auto', borderRadius: 20}}
            alt="Chairman"
          />
          </Col>

         
        </Row>

        {/* Chỉ hiển thị button nếu chưa expanded */}
        {!expanded ? 
          <div
          onClick={this.handleSeeMore}
          style={{
            display: 'inline-block',
            backgroundColor: '#ffffff',
            color: '#212121',
            borderRadius: 999,
            border: '1px solid #212121',
            padding: '8px 24px',
            fontSize: 16,
            fontWeight: 500,
            cursor: 'pointer',
            marginTop: 24,
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#000';
            e.currentTarget.style.color = '#fff';

          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#fff';
            e.currentTarget.style.color = '#212121';

          }}
        >
            {lang == "vi" ? "Xem thêm" :"See more"}
          </div>

        :  <div>
           
          <TextSection3
        title={""}
        paragraphs={content.bodyFull}
        marginBottom={0}

      /> <TextSection3
      title={content.sign.name}
      paragraphs={content.sign.title}
    /></div>}
      </section>
    );
  }
}

export default ChairmanMessage;
